export function isFloat(number: string | number) {
  if (typeof number === 'string') {
    number = parseFloat(number);
  }

  return !isNaN(number) && number % 1 !== 0;
}
